import { render } from "./ContactHeader.vue?vue&type=template&id=6c12ba29&ts=true"
import script from "./ContactHeader.vue?vue&type=script&lang=ts"
export * from "./ContactHeader.vue?vue&type=script&lang=ts"

import "./ContactHeader.vue?vue&type=style&index=0&id=6c12ba29&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__